import { Workflow, Users, Rocket, BadgeCheck, CalendarClock, Network, Handshake, Megaphone } from "lucide-react";
import { CAPABILITIES } from "@/data/content";
import { Reveal, ChapterBadge } from "@/components/Reveal";

const ICONS = {
  workflow: Workflow,
  users: Users,
  rocket: Rocket,
  badge: BadgeCheck,
  calendar: CalendarClock,
  network: Network,
  handshake: Handshake,
  megaphone: Megaphone,
};

export default function Capabilities() {
  return (
    <section id="capabilities" data-testid="capabilities-section" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ChapterBadge number="05" label="Core Capabilities" />
        <Reveal className="mt-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-charcoal-900 leading-[1.1] max-w-xl">
            What I bring <em className="italic text-copper-600">to the table.</em>
          </h2>
          <p className="text-base text-charcoal-600 max-w-md leading-relaxed">
            A capability set built over 14+ years of creative and operational work.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {CAPABILITIES.map((cap, i) => {
            const Icon = ICONS[cap.icon];
            return (
              <Reveal key={cap.title} delay={Math.min(i * 0.06, 0.36)}>
                <div
                  data-testid={`capability-card-${i}`}
                  className="group h-full bg-surface-white border border-charcoal-900/10 rounded-2xl p-7 hover:-translate-y-1.5 hover:shadow-xl hover:border-copper-600/30 transition-[transform,box-shadow,border-color] duration-300"
                >
                  <div className="w-11 h-11 rounded-full bg-copper-100 border border-copper-600/20 flex items-center justify-center text-copper-600 group-hover:bg-copper-600 group-hover:text-parchment transition-[background-color,color] duration-300">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="mt-5 text-[17px] font-semibold text-charcoal-900 leading-snug">{cap.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-charcoal-600">{cap.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
